"use client";

import { Check, Palette } from "lucide-react";
import { NOTE_COLORS, type NoteColor } from "@/lib/colors";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function ColorPicker({
  value,
  onChange,
  align = "center",
}: {
  value: NoteColor;
  onChange: (color: NoteColor) => void;
  align?: "start" | "center" | "end";
}) {
  return (
    <Popover>
      <PopoverTrigger
        render={
          <Button variant="ghost" size="icon-sm" aria-label="Cambiar color" title="Color">
            <Palette />
          </Button>
        }
      />
      <PopoverContent align={align} className="w-auto p-2">
        <div className="grid grid-cols-4 gap-1.5">
          {NOTE_COLORS.map((c) => (
            <button
              key={c.key}
              type="button"
              onClick={() => onChange(c.key as NoteColor)}
              aria-label={c.label}
              title={c.label}
              className={cn(
                "relative flex size-8 items-center justify-center rounded-full ring-1 ring-foreground/15 transition-transform hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                `swatch-${c.key}`,
              )}
            >
              {value === c.key && <Check className="size-4 text-foreground/80" />}
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
